// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditForm_profileForm__I34aW {
  width: 744px;
}
.EditForm_profileFormRow__yNAvo {
  display: flex;
  justify-content: space-between;
  margin: 24px 0px 16px;
}
.EditForm_profileFormColumn__YOasM {
  row-gap: 16px;
  width: 340px;
}
.EditForm_profileForm__I34aW,
.EditForm_profileFormColumn__YOasM,
.EditForm_mobileColumn__A\\+PTL {
  display: flex;
  flex-direction: column;
}
.EditForm_mobileColumn__A\\+PTL {
  align-items: baseline;
  justify-content: center;
}
.EditForm_label__oqfwX {
  text-align: left;
  color: #5f6d7e;
}
.EditForm_mobileRow__vZ630,
.EditForm_closeButton__92ntV,
.EditForm_saveButton__sZDEJ {
  display: flex;
  align-items: center;
}
.EditForm_mobileRow__vZ630 {
  justify-content: flex-start;
  width: 100%;
}
.EditForm_profileFormButtons__lH8wL {
  column-gap: 16px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.EditForm_closeButton__92ntV {
  background-color: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  height: 52px;
  width: 164px;
}
.EditForm_closeButtonText__IHkBw {
  color: #808080;
}
.EditForm_label__oqfwX,
.EditForm_closeButtonText__IHkBw,
.EditForm_saveButtonText__zshHs {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.EditForm_closeButtonText__IHkBw,
.EditForm_saveButtonText__zshHs {
  margin: 0px;
}
.EditForm_saveButton__sZDEJ {
  background-color: #cb9c2d;
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
  justify-content: center;
  width: 212px;
}
.EditForm_profileFormButtons__lH8wL {
  position: fixed;
  bottom: 24px;
  z-index: 99;
  left: 0;
}
.EditForm_saveButtonText__zshHs {
  color: #ffffff;
}
@media screen and (max-width: 1024px) {
  .EditForm_profileFormRow__yNAvo {
    flex-direction: column;
    align-items: baseline;
    width: 100%;
  }
  .EditForm_profileFormColumn__YOasM {
    width: 100%;
  }
  .EditForm_profileFormButtons__lH8wL {
    align-items: center;
    justify-content: center;
  }
  .EditForm_profileForm__I34aW {
    width: 95%;
  }
  .EditForm_saveButtonText__zshHs,
  .EditForm_closeButtonText__IHkBw {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/myProfile/components/EditForm/EditForm.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;;EAEE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,OAAO;AACT;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".profileForm {\n  width: 744px;\n}\n.profileFormRow {\n  display: flex;\n  justify-content: space-between;\n  margin: 24px 0px 16px;\n}\n.profileFormColumn {\n  row-gap: 16px;\n  width: 340px;\n}\n.profileForm,\n.profileFormColumn,\n.mobileColumn {\n  display: flex;\n  flex-direction: column;\n}\n.mobileColumn {\n  align-items: baseline;\n  justify-content: center;\n}\n.label {\n  text-align: left;\n  color: #5f6d7e;\n}\n.mobileRow,\n.closeButton,\n.saveButton {\n  display: flex;\n  align-items: center;\n}\n.mobileRow {\n  justify-content: flex-start;\n  width: 100%;\n}\n.profileFormButtons {\n  column-gap: 16px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.closeButton {\n  background-color: #ebebeb;\n  border-radius: 4px;\n  cursor: pointer;\n  justify-content: center;\n  height: 52px;\n  width: 164px;\n}\n.closeButtonText {\n  color: #808080;\n}\n.label,\n.closeButtonText,\n.saveButtonText {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.closeButtonText,\n.saveButtonText {\n  margin: 0px;\n}\n.saveButton {\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n  justify-content: center;\n  width: 212px;\n}\n.profileFormButtons {\n  position: fixed;\n  bottom: 24px;\n  z-index: 99;\n  left: 0;\n}\n.saveButtonText {\n  color: #ffffff;\n}\n@media screen and (max-width: 1024px) {\n  .profileFormRow {\n    flex-direction: column;\n    align-items: baseline;\n    width: 100%;\n  }\n  .profileFormColumn {\n    width: 100%;\n  }\n  .profileFormButtons {\n    align-items: center;\n    justify-content: center;\n  }\n  .profileForm {\n    width: 95%;\n  }\n  .saveButtonText,\n  .closeButtonText {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileForm": `EditForm_profileForm__I34aW`,
	"profileFormRow": `EditForm_profileFormRow__yNAvo`,
	"profileFormColumn": `EditForm_profileFormColumn__YOasM`,
	"mobileColumn": `EditForm_mobileColumn__A+PTL`,
	"label": `EditForm_label__oqfwX`,
	"mobileRow": `EditForm_mobileRow__vZ630`,
	"closeButton": `EditForm_closeButton__92ntV`,
	"saveButton": `EditForm_saveButton__sZDEJ`,
	"profileFormButtons": `EditForm_profileFormButtons__lH8wL`,
	"closeButtonText": `EditForm_closeButtonText__IHkBw`,
	"saveButtonText": `EditForm_saveButtonText__zshHs`
};
export default ___CSS_LOADER_EXPORT___;
